import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const processAuth = useCallback(async (sessionId) => {
    try {
      const response = await axios.post(
        `${API}/auth/session`,
        { session_id: sessionId },
        { withCredentials: true }
      );
      setUser(response.data);
      navigate('/dashboard', { replace: true, state: { user: response.data } });
    } catch (err) {
      console.error('Auth callback failed:', err.message);
      navigate('/login');
    }
  }, [navigate, setUser]);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    processAuth(sessionId);
  }, [navigate, processAuth]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-cabernet border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-body text-ink">Authenticating...</p>
      </div>
    </div>
  );
}
